module.exports = __webpack_public_path__ + "static/media/Avatar_4.7780c4a9.svg";